/* ============================================
   BUKNUWO Shopify Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  // ---- Mobile Menu ----
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      const isOpen = mobileNav.classList.contains('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      menuToggle.innerHTML = isOpen
        ? '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    });
  }

  // ---- Hero Slider ----
  initHeroSlider();

  // ---- FAQ Accordion ----
  // document.querySelectorAll('.faq-question').forEach(btn => {
  //   btn.addEventListener('click', () => {
  //     const item = btn.closest('.faq-item');
  //     const wasOpen = item.classList.contains('open');
  //     document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  //     if (!wasOpen) item.classList.add('open');
  //   });
  // });
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    item.classList.toggle('open');
  });
});

  // ---- Product Tabs ----
  document.querySelectorAll('.tab-nav button').forEach(btn => {
    btn.addEventListener('click', () => {
      const tabGroup = btn.closest('.product-tabs');
      tabGroup.querySelectorAll('.tab-nav button').forEach(b => b.classList.remove('active'));
      tabGroup.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      const target = tabGroup.querySelector(`[data-tab="${btn.dataset.tab}"]`);
      if (target) target.classList.add('active');
    });
  });

  // ---- Quantity Selector ----
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('[data-action="minus"]');
    const plus = selector.querySelector('[data-action="plus"]');
    if (minus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  // ---- Variant Buttons ----
  document.querySelectorAll('.variant-buttons').forEach(group => {
    group.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  });

  // ---- Product Thumbnails ----
  document.querySelectorAll('.product-thumbnails').forEach(thumbs => {
    thumbs.querySelectorAll('.product-thumbnail').forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const mainImg = thumb.closest('.product-gallery').querySelector('.product-main-image img');
        if (mainImg && thumb.dataset.src) {
          mainImg.src = thumb.dataset.src;
        }
      });
    });
  });

  // ---- Add to Cart (AJAX) ----
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' },
        });
        if (res.ok) {
          updateCartCount();
          showNotification('Product added to cart!');
        }
      } catch (err) {
        console.error('Add to cart failed:', err);
      }
    });
  });

  // ---- Sticky Header Shadow ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? 'var(--shadow-md)' : 'none';
    });
  }

  // ---- Scroll Animations ----
  const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.product-card, .category-card, .application-card, .testimonial-card, .why-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

  const style = document.createElement('style');
  style.textContent = '.animate-in { opacity: 1 !important; transform: translateY(0) !important; }';
  document.head.appendChild(style);
});

/* ---- Hero Slider ---- */
function initHeroSlider() {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  if (slides.length <= 1) return;

  let current = 0;
  let interval;

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current]?.classList.remove('active');
    current = index;
    slides[current].classList.add('active');
    dots[current]?.classList.add('active');
  }

  function next() {
    goTo((current + 1) % slides.length);
  }

  function startAutoplay() {
    interval = setInterval(next, 5000);
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      clearInterval(interval);
      goTo(i);
      startAutoplay();
    });
  });

  startAutoplay();
}

/* ---- Update Cart Count ---- */
async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const badge = document.querySelector('.cart-count');
    if (badge) badge.textContent = cart.item_count;
  } catch (err) {
    console.error('Failed to update cart count:', err);
  }
}

/* ---- Notification ---- */
function showNotification(message) {
  const existing = document.querySelector('.cart-notification');
  if (existing) existing.remove();

  const el = document.createElement('div');
  el.className = 'cart-notification';
  el.style.cssText = `
    position: fixed; top: 100px; right: 24px; z-index: 9999;
    background: #065f46; color: #fff; padding: 16px 24px;
    border-radius: 8px; font-size: 0.9375rem; font-weight: 500;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    animation: slideIn 0.3s ease;
  `;
  el.textContent = message;
  document.body.appendChild(el);

  const anim = document.createElement('style');
  anim.textContent = '@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }';
  document.head.appendChild(anim);

  setTimeout(() => {
    el.style.transition = 'all 0.3s ease';
    el.style.opacity = '0';
    el.style.transform = 'translateX(100%)';
    setTimeout(() => el.remove(), 300);
  }, 3000);
}
